/* @flow */
import React from 'react';
import FotosHelper from '../../helpers/FotosHelper';

export default function AACargando() {
    return (
        <img elem="cargando" src={FotosHelper.imgV4("aa-cargando_200.gif")} alt="Cargando" />
    );
}